import { Translatable } from "@icc/shared/helpers";

/** Izolacja */
export class BoxesIsolation {
    id: number;
    /** Kod zewnętrzny */
    extId?: string;
    /** Kod do indeksu */
    indexNo?: string;
    @Translatable({ model: 'WindowAccessories' })
    name?: string;
    img?: string;
    description?: string;
    shortDescription?: string;
    /** Przypisane typy skrzynek */
    blindBoxTypesIds?: number[];
    /** Wysokość izolacji [mm] */
    insulationHeight?: number;
    /** Czy ustawione automatycznie */
    isDefault?: boolean;
    /** Nadmiarowa izolacja [mm] */
    wasteFactor?: number;
    product?: number;
    /** Liczba izolacji */
    amount?: number;
    /** Waga */
    weight?: number;
    /** Waga stała */
    weightConst?: number;
    /** Kolejność */
    order: number;
}